import React, { useState, useEffect } from 'react';
import { isAuthenticated } from './utils/auth';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
// ...existing code...
import CallbackPage from './components/CallbackPage';
// ...existing code...
// import TestBubblesCSS from './components/TestBubblesCSS'; // rimosso: non usato
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';

function App() {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    isLoading: true
  });

  useEffect(() => {
    // Check authentication status on app load
    const checkAuth = () => {
      const authenticated = isAuthenticated();
      setAuthState({
        isAuthenticated: authenticated,
        isLoading: false
      });
    };

    checkAuth();
  }, []);

  const handleAuthSuccess = () => {
    setAuthState({
      isAuthenticated: true,
      isLoading: false
    });
  };

  // Show loading spinner while checking authentication
  if (authState.isLoading) {
    return (
      <div className="App">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Render the app with routes
  return (
    <div className="App">
      <Routes>
    <Route path="/" element={authState.isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage />} />
    <Route path="/dashboard" element={authState.isAuthenticated ? <Dashboard /> : <Navigate to="/" />} />
    <Route path="/callback" element={<CallbackPage onAuthSuccess={handleAuthSuccess} />} />
      </Routes>
    </div>
  );
}

export default App;
